import React, { useEffect, useState } from "react";
import "../../Stylesheets/OurWorkFlow/OurWorkFlow.scss";
import workflow from "../../assests/Images/Workflow/workflow-img.png";
import img1 from "../../assests/Images/Workflow/costestimation.png";
import img2 from "../../assests/Images/Workflow/discoverycall.png";
import img3 from "../../assests/Images/Workflow/create.png";
import img4 from "../../assests/Images/Workflow/shoot.png";
import img5 from "../../assests/Images/Workflow/showcase.png";

const OurWorkFlow = () => {
  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  return (
    <div className="ourworkflow-main-wrapper">
      <div className="ourworkflow-inner-wrapper">
        <div className="ourworkflow-heading">
          <button>
            <span className="our-work-flow">Our </span>
            Workflow
          </button>
        </div>
        {windowSize[0] < 584  && (
          <div className="workflow-outer-contain">
            <div className="workflow-inner-contain">
              {/* <img src={workflow} alt="workflow" className="workflow-img"></img> */}
              <div className="images-main-wrapper">
                <div className="line-design-wrap">
                  <div className="blue-dot-one"></div>
                  <div className="line"></div>
                  {/* one */}
                  <div className="image-circle-up">
                    <img src={img2} className="workflowimage-up"></img>
                    <div className="image-name-up">Discover Call</div>
                  </div>

                  {/* two */}
                  <div className="image-circle-down">
                    <div className="image-name-down">Cost Estimation</div>
                    <img src={img1} className="workflowimage-down"></img>
                  </div>

                  {/* three */}
                  <div className="image-circle-up">
                    <img src={img4} className="workflowimage-up"></img>
                    <div className="image-name-up">Shoot</div>
                  </div>

                  {/* four */}
                  <div className="image-circle-down">
                    <div className="image-name-down">Create</div>
                    <img src={img3} className="workflowimage-down"></img>
                  </div>

                  {/* five */}
                  <div className="image-circle-up">
                    <img src={img5} className="workflowimage-up"></img>
                    <div className="image-name-up">Show Case</div>
                  </div>

                  <div className="blue-dot-two"></div>
                </div>
              </div>
            </div>
          </div>
        )}
        {windowSize[0] > 584 && windowSize[0]<1146 && (
          <div className="workflow-outer-contain_mobileview">
            <div className="workflow-inner-contain">
              {/* <img src={workflow} alt="workflow" className="workflow-img"></img> */}
              <div className="images-main-wrapper_top">
                <div className="line-design-wrap">
                  <div className="blue-dot-one"></div>
                  <div className="line"></div>
                  {/* one */}
                  <div className="image-circle-up">
                    <img src={img2} className="workflowimage-up"></img>
                    <span className="image-name-up">Discover Call</span>
                  </div>
                  {/* two */}
                  <div className="image-circle-down">
                    <span className="image-name-down">Cost Estimation</span>
                    <img src={img1} className="workflowimage-down"></img>
                  </div>
                  {/* three */}
                  <div className="image-circle-up">
                    <img src={img4} className="workflowimage-up"></img>
                    <span className="image-name-up">Shoot</span>
                  </div>
                </div>
              </div>
              <div className="images-main-wrapper_bottom">
                <div className="line-design-wrap">
                <div className="line"></div>
                <div className="line_vertical"></div>
                  {/* four */}
                  <div className="blue-dot-two"></div>
                  <div className="image-circle-down">
                    <span className="image-name-down">Create</span>
                    <img src={img3} className="workflowimage-down"></img>
                  </div>
                  {/* five */}
                  <div className="image-circle-up">
                    <img src={img5} className="workflowimage-up"></img>
                    <span className="image-name-up">Show Case</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {windowSize[0] >= 1147 && (
          <div className="workflow-outer-contain">
            <div className="workflow-inner-contain">
              {/* <img src={workflow} alt="workflow" className="workflow-img"></img> */}
              <div className="images-main-wrapper">
                <div className="line-design-wrap">
                  <div className="blue-dot-one"></div>
                  <div className="line"></div>
                  {/* one */}
                  <div className="image-circle-up">
                    <img src={img2} className="workflowimage-up"></img>
                    <span className="image-name-up">Discover Call</span>
                  </div>

                  {/* two */}
                  <div className="image-circle-down">
                    <span className="image-name-down">Cost Estimation</span>
                    <img src={img1} className="workflowimage-down"></img>
                  </div>

                  {/* three */}
                  <div className="image-circle-up">
                    <img src={img4} className="workflowimage-up"></img>
                    <span className="image-name-up">Shoot</span>
                  </div>

                  {/* four */}
                  <div className="image-circle-down">
                    <span className="image-name-down">Create</span>
                    <img src={img3} className="workflowimage-down"></img>
                  </div>

                  {/* five */}
                  <div className="image-circle-up">
                    <img src={img5} className="workflowimage-up"></img>
                    <span className="image-name-up">Show Case</span>
                  </div>

                  <div className="blue-dot-two"></div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OurWorkFlow;
